<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новые коды',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новые коды',
			items: [],
            trackBy: 'id',

			code: null,
			from_phone: null,
			until_phone: null,
			c: null,
			provider: null,
			region_name: null,

			region: null,
			regions_options: [],
			initRegions: [],

			country: null,
			countries_options: [],
			initCountries: [],


		}
	},
    
	watch: {
	    initRegions: {
            immediate: true,
            handler(values) {
                this.region = this.regions_options.filter(x => values.includes(x[this.trackBy]));
                this.region = this.region[0];
            }
        },
	    initCountries: {
            immediate: true,
            handler(values) {
                this.country = this.countries_options.filter(x => values.includes(x[this.trackBy]));
                this.country = this.country[0];
            }
        },

	},

	computed: {
	    regions_list_data(){
            return this.$store.getters['regions/GET_REGIONS_LIST_DATA'];
        },
	    countries_list_data(){
            return this.$store.getters['countries/GET_COUNTRIES_LIST_DATA'];
        },
	    item(){
            return this.$store.getters['phonesCodes/GET_PHONES_CODES_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        this.item_uuid = this.$route.params.uuid ? this.$route.params.uuid : '';

        await this.$store.dispatch('phonesCodes/FETCH_PHONES_CODES_LIST', {});
        this._options = this._list_data;

        await this.$store.dispatch('regions/FETCH_REGIONS_LIST', {});
        this.regions_options = this.regions_list_data;

        await this.$store.dispatch('countries/FETCH_COUNTRIES_LIST', {});
        this.countries_options = this.countries_list_data;


        if(this.item_uuid !== ''){
    
            this.title = 'Редактирование кодов';
            document.title = 'Редактирование кодов' + ' | ' + appConfig.title;
    
            await this.$store.dispatch('phonesCodes/FETCH_PHONES_CODES_ITEM', {'uuid': this.item_uuid});

            this.code = this.item.code ? this.item.code : null;
            this.from_phone = this.item.from_phone ? this.item.from_phone : null;
            this.until_phone = this.item.until_phone ? this.item.until_phone : null;
            this.c = this.item.c ? this.item.c : null;
            this.provider = this.item.provider ? this.item.provider : null;
            this.region_name = this.item.region_name ? this.item.region_name : null;

            this.region = this.item.region_id ? this.item.region_id : null;
            if (this.region !== null) {
                this.initRegions = [this.region];
            }

            this.country = this.item.country_id ? this.item.country_id : null;
            if (this.country !== null) {
                this.initCountries = [this.country];
            }
        }
	},

	methods: {
        async saveItem(){

        let data_send = {
            'code': this.code,
            'from_phone': this.from_phone,
            'until_phone': this.until_phone,
            'c': this.c,
            'provider': this.provider,
            'region_name': this.region_name,
            'region_id': this.region && this.region.id ? this.region.id : null,
            'country_id': this.country && this.country.id ? this.country.id : null,

        };
    
        let result = '';
    
        if(this.item_uuid === ''){
            result = await this.$store.dispatch('phonesCodes/FETCH_PHONES_CODES_CREATE', data_send);
        } else {
            data_send.uuid = this.item_uuid;
            result = await this.$store.dispatch('phonesCodes/FETCH_PHONES_CODES_UPDATE', data_send);
        }
    
        if(result === false){
            alert('Возникла ошибка');
        } else {
            this.$router.push({ name: 'Phones.Codes'});
        }
    }
	}

}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <b-form-group
                                        label="Код оператора"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Начальный номер"
                                        label-for="from_phone"
                                    >
                                        <b-form-input
                                            id="from_phone"
                                            v-model="from_phone"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Конечный номер"
                                        label-for="until_phone"
                                    >
                                        <b-form-input
                                            id="until_phone"
                                            v-model="until_phone"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Количество"
                                        label-for="c"
                                    >
                                        <b-form-input
                                            id="c"
                                            v-model="c"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Оператор связи"
                                        label-for="provider"
                                    >
                                        <b-form-input
                                            id="provider"
                                            v-model="provider"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Название региона"
                                        label-for="region_name"
                                    >
                                        <b-form-input
                                            id="region_name"
                                            v-model="region_name"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Регион"
                                        label-for="region"
                                    >
                                        <multiselect
                                            id="region"
                                            v-model="region"
                                            :options="regions_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Страна"
                                        label-for="country"
                                    >
                                        <multiselect
                                            id="country"
                                            v-model="country"
                                            :options="countries_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
